module.exports = __webpack_public_path__ + "img/burger-icon.09d2d52c.svg";